import { render, staticRenderFns } from "./ExamsEvaluation.vue?vue&type=template&id=32c086ec"
import script from "./ExamsEvaluation.vue?vue&type=script&lang=js"
export * from "./ExamsEvaluation.vue?vue&type=script&lang=js"
import style0 from "./ExamsEvaluation.vue?vue&type=style&index=0&id=32c086ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports